angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/landing.html',
    'Landing Page');
}]);
